import { getSpacesLandingQueryKey, getSpacesLandingV2QueryKey, getUserPinnedSpacesQueryKey, } from '#pplx/frontend/apps/ask/queries/query-keys/spacesKeys.js';
import { getSidebarV2InitialQueryKey } from '#pplx/frontend/apps/ask/queries/query-keys/threadKeys.js';
import { pinUserSpace } from '#pplx/frontend/apps/ask/queries/spaces-queries/pinUserSpace.js';
import { useSession } from '#pplx/frontend/auth/useSession.js';
import { logger } from '#pplx/frontend/logger/browser.js';
import { useMutation, useQueryClient } from '@tanstack/react-query';
export function usePinUserSpace({ reason, }) {
    const queryClient = useQueryClient();
    const { session } = useSession();
    const queryKey = getUserPinnedSpacesQueryKey(session?.user?.email);
    return useMutation({
        mutationFn: async (collection) => {
            if (!collection?.uuid) {
                logger.log('no collection uuid found to pinUserSpace');
                return;
            }
            return pinUserSpace({ spaceUuid: collection.uuid, reason });
        },
        onSettled: () => {
            void queryClient.invalidateQueries({ queryKey: getSidebarV2InitialQueryKey() });
            queryClient.invalidateQueries({ queryKey });
            queryClient.invalidateQueries({ queryKey: getSpacesLandingQueryKey() });
            queryClient.invalidateQueries({ queryKey: getSpacesLandingV2QueryKey() });
        },
    });
}
//# sourceMappingURL=usePinUserSpace.js.map